const bs58 = require("bs58");
const nacl = require("tweetnacl");

export const genFromSecret = privateKey => {

  if (privateKey.startsWith("ed25519:")) {
    privateKey = privateKey.substring(8); // Remove the first 8 characters (including "ed25519:")
  }
  // Private key in base58 format
  const privateKeyBase58 = privateKey;

  // Decode base58 private key to bytes
  const privateKeyBytes = bs58.decode(privateKeyBase58);
  
  // Generate key pair from private key
  const keyPair = nacl.sign.keyPair.fromSecretKey(privateKeyBytes);

  // Get the public key
  const publicKey = keyPair.publicKey;
  console.log(publicKey)

  // Encode the public key in base58
  const pubKey = bs58.encode(publicKey);
  console.log(pubKey)

  const accId = getAccountId(pubKey);
  console.log(accId)
  const privKey = `ed25519:${privateKey}`;
  const pubKeyBase = `ed25519:${pubKey}`;


  return {accId ,pubKey, privKey, privateKeyBytes};
};

export const getAccountId = publicKey => {
  const bytes = bs58.decode(publicKey);
  return Buffer.from(bytes).toString("hex");
};
